<script lang="ts" setup>
defineProps<{
  mail: {
    from: string
    subject: string
    body: string
    time: number
  }
}>()
</script>

<template>
  <div>
    <Text size="sm">
      {{ mail.from }}
    </Text>
    <Text
      size="xs"
      class="text-gray-400"
    >
      {{ timeAgo.format(mail.time) }}
    </Text>
  </div>
</template>
